import type { NavItem } from '@/layout/nav';
import { PageHeader } from '@/components/PageHeader';
import { EmptyState } from '@/components/EmptyState';
import { Card } from '@/components/ui/card';

export function ComingSoonPage({ item }: { item: NavItem }) {
  return (
    <>
      <PageHeader title={item.label} icon={item.icon3d} />
      <Card>
        <EmptyState art={item.icon3d} title="העמוד הזה בבנייה">
          הוא ייפתח באחד השלבים הבאים של הבנייה ({item.milestone}).
        </EmptyState>
      </Card>
    </>
  );
}

export function NotFoundPage() {
  return <EmptyState title="העמוד לא נמצא">ייתכן שהקישור שגוי. חזרו לעמוד הבית דרך התפריט.</EmptyState>;
}
